import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取店铺配置列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getShopConfigList(params) {
  return new Promise((resolve, reject) => {
    const defaultParams = {
      shopId: getShopId(),
      ...params
    }
    request({
      url: '/shopConfig.listShopConfig',
      method: 'get',
      params: defaultParams
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新店铺配置
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateShopConfig(data) {
  return new Promise((resolve, reject) => {
    if (!data.shopId) {
      data.shopId = getShopId()
    }
    request({
      url: '/shopConfig.updateShopConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}